<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 7h12M8 12h12M8 17h12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
<path d="M4 7h.01M4 12h.01M4 17h.01" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>
</svg>
</template>
